import React from "react";
import svg43 from "../../../../assets/svg/svg43.svg";
import { Progress } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { numberWithCommas } from "../../../../utils";
function MonthlyProgressCard() {
 const url = "project/fetch_projects";
  const navigate = useNavigate();
  const dispatch =  useDispatch() 
  const { activeObjMontProj, data } = useSelector((state) => ({
    activeObjMontProj: state.obj.activeObj["monthlyProj"],
    data: state.fetch.data[url] || [],
  }));
  const items = [
    {
      title: "Contract Sum",
      amount:  data?.[0]?.projectCost,
    },
   
    {
      title: "Disbursed Sum",
      progress: Number(data?.[0]?.projectDisbursementPercentage)?.toFixed(2),
      amount: Number(data?.[0]?.projectTotalDisbursement)?.toFixed(2),
    },
    
    {
      title: "Cummulative Expenditure FYN",
      amount:  data?.[0]?.projActualCummulative,
    },
  ];
  return (
    <div className="flex flex-shrink flex-wrap  gap-y-[1rem] gap-x-[1rem] mt-[1rem]">
      {items &&
        items?.map((item) => (
          <div className="rounded-[.5rem] border cursor-pointer border-[#D6E1F5] px-[.625rem] py-[1rem] h-auto bg-[#F7F7F7] w-auto lg:min-w-[190px]">
            <div className="flex items-center justify-between">
              <div
                className={`flex flex-col ${item?.progress ? "" : "w-full"}`}
              >
                <div className="flex  items-center justify-between">
                  <span className="font-interSans text-[.75rem] font-[500] text-[#0092CC]">
                    {item?.title}
                  </span>
                  <img src={svg43} alt="svg43" />
                </div>
                <div className="form-add-h !text-[#050505] mt-[1.44rem]">
                  {numberWithCommas(item?.amount)}
                </div>
              </div>

              {item?.progress && (
                <div className="flex items-center flex-shrink-0">
                  <Progress
                    className="object-contain w-[60px] h-[60px]"
                    type="circle"
                    percent={item?.progress}
                    strokeColor="#4FAD5B"
                    width={60}
                  />
                </div>
              )}
            </div>
          </div>
        ))}
    </div>
  );
}

export default MonthlyProgressCard;
